import React from 'react';
export const DashboardIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='15'
      viewBox='0 0 15 15'
    >
      <g data-name='Group 2583' transform='translate(0 0)'>
        <path
          data-name='Path 2129'
          d='M1667.731,877.683a3.066,3.066,0,1,1-3.067-3.068A3.061,3.061,0,0,1,1667.731,877.683Z'
          transform='translate(-1652.731 -865.747)'
          fill='currentColor'
        />
        <path
          data-name='Path 2130'
          d='M1471.213,874.615a3.066,3.066,0,1,1-3.072,3.064A3.06,3.06,0,0,1,1471.213,874.615Z'
          transform='translate(-1468.141 -865.747)'
          fill='currentColor'
        />
        <path
          data-name='Path 2131'
          d='M1474.272,684.227a3.066,3.066,0,1,1-3.044-3.075A3.063,3.063,0,0,1,1474.272,684.227Z'
          transform='translate(-1468.14 -681.152)'
          fill='currentColor'
        />
        <path
          data-name='Path 2132'
          d='M1674.436,691.284q0,1.143,0,2.286c0,.335-.107.441-.443.441h-4.572c-.326,0-.438-.108-.438-.43q0-2.295,0-4.589c0-.323.111-.433.435-.433h4.572c.344,0,.445.105.446.455Q1674.436,690.149,1674.436,691.284Z'
          transform='translate(-1659.775 -688.219)'
          fill='currentColor'
        />
      </g>
    </svg>
  );
};
